import { Image } from '#app/components/Image/Image.js';
import { Flex } from '#app/components/Layout/components/Flex/Flex.js';
import { Link } from '#app/components/Link/index.js';
import { Text } from '#app/components/Primitives/Text.js';
import { NewProjectButton } from '#app/features/paidProjects/components/NewProjectButton/NewProjectButton.js';
import { useSelectedUserType } from '#app/hooks/useSelectedUserType.js';
import { useStartProjectCopy } from '#app/hooks/useStartProjectCopy.js';
import jennyChill from './assets/jenny-chill.webp';
import { getRoute } from '@contra/routes';
import { css, styled } from 'styled-components';

const Container = styled.div`
  ${({ theme }) => css`
    border-radius: 20px;
    background-color: ${theme.colorsV2.white};
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 32px;
    text-align: center;
    width: 100%;
    gap: 24px;

    > * {
      max-width: 500px;
    }
  `}
`;

const TextLink = styled(Link)`
  ${({ theme }) => css`
    text-decoration: none;
    border-bottom: 1px solid ${theme.colorsV2.yellow40};
  `}
`;

const LearnMoreLink = () => {
  return (
    <TextLink
      to={`${getRoute('/p/@slug', {
        args: {
          slug: 'Qk77kOsm-boost-your-reputation-with-recommendations',
        },
      })}?utm_source=Recommendations&utm_medium=Boost-Your-Reputation-With-Recommendations&utm_campaign=Tips-Blog`}
    >
      {' '}
      Learn more about recommendations.{' '}
    </TextLink>
  );
};

export const EmptyState = () => {
  const { selectedUserType } = useSelectedUserType();
  const { label } = useStartProjectCopy();

  const userPersonaWithArticle =
    selectedUserType === 'CONTRACTOR' ? 'an Independent' : 'a Client';

  return (
    <Container>
      <Image
        height={184}
        src={jennyChill}
        width={333}
      />
      <Text textStyle="fifthLevelHeadline">
        You haven't received any recommendations as {userPersonaWithArticle}{' '}
        yet!
      </Text>

      {selectedUserType === 'CONTRACTOR' ? (
        <Flex>
          <Text textStyle="bodyRegular">
            Complete a paid project to receive a recommendation. These help
            boost your reputation on Contra and get you matched with top paid
            jobs!
          </Text>
          <LearnMoreLink />
        </Flex>
      ) : (
        <Flex>
          <Text textStyle="bodyRegular">
            Recommendations boost your reputation and get you access to top
            freelancers on Contra. Complete a paid project to receive a
            recommendation.
          </Text>
          <LearnMoreLink />
        </Flex>
      )}

      <NewProjectButton
        label={selectedUserType === 'CONTRACTOR' ? label : undefined}
        userType={selectedUserType === 'CONTRACTOR' ? 'independent' : 'client'}
      />
    </Container>
  );
};
